import { render } from "./FeaturedBrandsComponent.vue?vue&type=template&id=42070764"
import script from "./FeaturedBrandsComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedBrandsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/FeaturedBrandsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42070764"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42070764', __exports__)) {
    api.reload('42070764', __exports__)
  }
  
  module.hot.accept("./FeaturedBrandsComponent.vue?vue&type=template&id=42070764", () => {
    api.rerender('42070764', render)
  })

}


export default __exports__